import { render, staticRenderFns } from "./ActionRegister.vue?vue&type=template&id=2407d61c&scoped=true&"
import script from "./ActionRegister.vue?vue&type=script&lang=js&"
export * from "./ActionRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407d61c",
  null
  
)

export default component.exports